import * as THREE from 'three';
import { isObject3D, isOrthographicCamera } from '../checking';

const bbox = /* @__PURE__ */ new THREE.Box3();
const v1 = /* @__PURE__ */ new THREE.Vector3();
const v2 = /* @__PURE__ */ new THREE.Vector3();

/**
 * @link https://wejn.org/2020/12/cracking-the-threejs-object-fitting-nut/
 * @link https://threejs.org/docs/#api/en/cameras/PerspectiveCamera
 */
export const fitCameraToBounds = (
  bounds: THREE.Box3 | THREE.Object3D,
  camera: THREE.PerspectiveCamera | THREE.OrthographicCamera,
  margin: number = 1,
  view: THREE.Vector3 = new THREE.Vector3(0, 1, 0),
  target: THREE.Vector3 = new THREE.Vector3(),
) => {
  const forward = camera.up;

  const rotation = new THREE.Matrix4().makeRotationFromQuaternion(
    new THREE.Quaternion().setFromUnitVectors(forward, view),
  );

  const box = isObject3D(bounds) ? bbox.setFromObject(bounds) : bounds;

  box.applyMatrix4(rotation);

  const boxSize = box.getSize(v1);
  const center = box.getCenter(v2);
  const maxSize = Math.max(boxSize.x, boxSize.y, boxSize.z);
  const fitHeightDistance = isOrthographicCamera(camera)
    ? maxSize * 4
    : maxSize / (2 * Math.atan((Math.PI * camera.fov) / 360));
  const fitWidthDistance = isOrthographicCamera(camera)
    ? maxSize * 4
    : fitHeightDistance / camera.aspect;
  const distance = margin * Math.max(fitHeightDistance, fitWidthDistance);

  return target.copy(center).add(view.multiplyScalar(distance));
};
